import axios from "axios";
import { config } from "../config/config";

const api = axios.create({
  baseURL: config.api.baseURL,
  timeout: config.api.timeout,
  headers: {
    "Content-Type": "application/json",
  },
});

// Pages API with full CRUD
export const pagesApi = {
  getAll: (includeInactive = false) =>
    api.get(`/pages/?include_inactive=${includeInactive}`),
  getBySlug: (slug) => api.get(`/pages/${slug}`),
  getByPageType: (type) => api.get(`/pages/type/${type}`),
  getById: (id) => api.get(`/pages/id/${id}`),
  create: (data) => api.post("/pages/", data),
  update: (id, data) => api.put(`/pages/${id}`, data),
  delete: (id) => api.delete(`/pages/${id}`),
};

// Programs API with full CRUD
export const programsApi = {
  getAll: (includeInactive = false) =>
    api.get(`/programs/?include_inactive=${includeInactive}`),
  getBySlug: (slug) => api.get(`/programs/${slug}`),
  getById: (id) => api.get(`/programs/id/${id}`),
  create: (data) => api.post("/programs/", data),
  update: (id, data) => api.put(`/programs/${id}`, data),
  delete: (id) => api.delete(`/programs/${id}`),
  getCategories: () => api.get("/programs/categories/list"),
};

// Program Categories API
export const categoriesApi = {
  getAll: () => api.get("/program-categories/"),
  getById: (id) => api.get(`/program-categories/${id}`),
  create: (data) => api.post("/program-categories/", data),
  update: (id, data) => api.put(`/program-categories/${id}`, data),
  delete: (id) => api.delete(`/program-categories/${id}`),
};

// Blog API with full CRUD
export const blogApi = {
  getAll: (publishedOnly = false) =>
    api.get(`/blog/?published_only=${publishedOnly}`),
  getBySlug: (slug) => api.get(`/blog/${slug}`),
  getById: (id) => api.get(`/blog/id/${id}`),
  create: (data) => api.post("/blog/", data),
  update: (id, data) => api.put(`/blog/${id}`, data),
  delete: (id) => api.delete(`/blog/${id}`),
};

// Home API
export const homeApi = {
  getFeaturedPrograms: () => api.get("/home/featured-programs"),
  getServices: () => api.get("/home/services"),
  getLatestInsights: (limit = 3) =>
    api.get(`/home/latest-insights?limit=${limit}`),
  subscribeNewsletter: (data) => api.post("/home/newsletter/subscribe", data),
};

// Home Page API
export const homepageApi = {
  getHero: () => api.get("/homepage/hero"),
  updateHero: (data) => api.put("/homepage/hero", data),
  getFeaturedPrograms: () => api.get("/homepage/featured-programs"),
  updateFeaturedPrograms: (programIds) =>
    api.put("/homepage/featured-programs", programIds),
  getServices: () => api.get("/homepage/services"),
  createService: (data) => api.post("/homepage/services", data),
  updateService: (id, data) => api.put(`/homepage/services/${id}`, data),
  deleteService: (id) => api.delete(`/homepage/services/${id}`),
};

// Admin Dashboard API
export const adminApi = {
  getDashboardStats: () => api.get("/admin/dashboard"),
};

// About API
export const aboutApi = {
  getSections: () => api.get("/about/sections"),
  getSectionById: (id) => api.get(`/about/sections/${id}`),
  getWhyChooseUs: () => api.get("/about/why-choose-us"),
  getWhyChooseUsItem: (id) => api.get(`/about/why-choose-us/${id}`),
  getSectionByType: (type) => api.get(`/about/section/${type}`),
  createSection: (data) => api.post("/about/sections", data),
  updateSection: (id, data) => api.put(`/about/sections/${id}`, data),
  deleteSection: (id) => api.delete(`/about/sections/${id}`),
  createWhyChooseUsItem: (data) => api.post("/about/why-choose-us", data),
  updateWhyChooseUsItem: (id, data) =>
    api.put(`/about/why-choose-us/${id}`, data),
  deleteWhyChooseUsItem: (id) => api.delete(`/about/why-choose-us/${id}`),
};

// Services API (Consulting, Coaching, Corporate Training)
export const servicesApi = {
  // Consulting
  getConsultingFocusAreas: () => api.get("/services/consulting/focus-areas"),
  getConsultingFocusArea: (id) =>
    api.get(`/services/consulting/focus-areas/${id}`),
  getConsultingProcess: () => api.get("/services/consulting/process"),
  getConsultingProcessStep: (id) =>
    api.get(`/services/consulting/process/${id}`),

  // Coaching
  getCoachingOptions: () => api.get("/services/coaching/options"),
  getCoachingOption: (id) => api.get(`/services/coaching/options/${id}`),
  getCoachingTestimonials: () => api.get("/services/coaching/testimonials"),
  getCoachingTestimonial: (id) =>
    api.get(`/services/coaching/testimonials/${id}`),

  // Corporate Training
  getCorporateTrainingPrograms: () =>
    api.get("/services/corporate-training/programs"),
  getCorporateTrainingProgram: (id) =>
    api.get(`/services/corporate-training/programs/${id}`),
  getCorporateTrainingBenefits: () =>
    api.get("/services/corporate-training/benefits"),
  getCorporateTrainingProcess: () =>
    api.get("/services/corporate-training/process"),
  getCorporateTrainingSections: () =>
    api.get("/services/corporate-training/sections"),
  updateCorporateTrainingSections: (data) =>
    api.put("/services/corporate-training/sections", data),
};

export default api;
